
import ReactApexChart from 'react-apexcharts';

const PendingExpensesPieChart = ({ getUserDashboard }: any) => {

  // Extract data from the API response
  const allExpense = getUserDashboard?.result?.allExpense || 0;
  const totalExpenseAmount = getUserDashboard?.result?.totalExpenseAmount || 0;

  // Chart options
  const pieChartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: ['Number of Expenses', 'Total Expenses Amount'],
    colors: ['#0A47E6', '#00945F'],
    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'center',
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 250,
          },
          legend: {
            position: 'bottom',
            horizontalAlign: 'center',
          },
        },
      },
    ],
    tooltip: {
      y: [{},{
        formatter: function (value: any) {
          return `$${value.toLocaleString('en-US')}`;
        },
      }],
    },
  };

  // Chart series data
  const pieChartSeries = [allExpense, totalExpenseAmount];

  return (
    <div className='d-flex justify-content-center align-items-center w-100'>
      {allExpense === 0 && totalExpenseAmount === 0 ? (
        <p className='mt-15'>Chart does not have any values to display.</p>
      ) : (
        <div className='legend-center'>
          <ReactApexChart options={pieChartOptions} series={pieChartSeries} type="donut" height={300} />
        </div>
      )}
    </div>
  )
}

export default PendingExpensesPieChart